<template>
  <v-flex>
    <div
      v-for="article in articles"
      class="article"
    >
      <h3
        class="m-title"
      >
        <a
          :href="article._source.url"
          target="_blank"
        >{{ article._source.title }}</a>
      </h3>
      <div
        class="infa"
      >
        <v-icon small>access_time</v-icon>
        {{ article._source.human_date }}
        <v-icon small>cloud</v-icon>
        {{ article._source.site_name }}
      </div>
      <div
        class="content"
        v-html="getHighlights(article)"
      ></div>
      <div
        class="similar-wrap"
        v-if="_.get(article, 'similar', []).length > 0"
      >
        <div class="subheading">Similar articles:</div>
        <div
          class="similar"
          v-for="similar in article.similar"
        >
          <a
            :href="similar._source.url"
            target="_blank"
          >{{ similar._source.title }}</a>
          <div>
            <v-icon small>access_time</v-icon>
            {{ similar._source.human_date }}
            <v-icon small>cloud</v-icon>
            {{ similar._source.site_name }}
          </div>
        </div>
      </div>

      <br />
      <v-icon small>thumb_up_alt</v-icon>
      {{ article._source.engagement.reaction_count }}
      <v-icon small>comment</v-icon>
      {{ article._source.engagement.comment_count }}
      <v-icon small>share</v-icon>
      {{ article._source.engagement.share_count }}
    </div>

    <v-pagination
      :length="length"
      :total-visible="10"
      v-model="page"
      @input="getArticles"
      v-show="length > 0 && loading === false"
    ></v-pagination>

    <v-progress-linear
      :indeterminate="true"
      v-show="loading"
    ></v-progress-linear>
    <v-alert
      type="warning"
      :value="articles.length === 0 && loading === false && error === false"
    >
      No results found.
    </v-alert>
    <v-alert
      type="error"
      :value="error === true"
    >
      Oops, something went wrong! Please contact us, if this problem repeats.
    </v-alert>
  </v-flex>
</template>

<script>
  export default {
    props: ['search'],
    data () {
      return {
        selected: [],
        articles: [],
        loading: false,
        error: false,
        page: 1,
        length: 0
      }
    },
    methods: {
      getHighlights (article) {
        let html = ''
        for (let h of article.highlight.content) {
          html += h + '...'
        }
        return html
      },
      async getArticles (page) {
        if (this._.isUndefined(this.search)) {
          return
        }
        try {
          this.articles = []
          this.error = false
          this.loading = true
          const data = await this.$axios.get('/search', {
            params: {
              page: page,
              id: this.search.id
            }
          })
          this.articles = data.data.documents
          this.setPaginationLength(data.data.total)
          this.loading = false
        } catch (e) {
          this.error = true
          this.loading = false
        }
      },
      setPaginationLength (total) {
        let pages = parseInt(total / 25)
        if (pages * 25 < total) {
          pages += 1
        }
        if (pages * 25 > 10000) {
          pages = 400
        }
        this.length = pages
      }
    },
    watch: {
      search () {
        this.getArticles()
      }
    },
    mounted () {
      this.getArticles()
    }
  }
</script>

<style>
  .highlight {
    background-color: #ff9;
    height: 20px;
  }
</style>

<style scoped>
  .similar-wrap {
    padding-left: 40px;
  }
  .subheading {
    margin-top: 10px;
  }
  .content {
    display: block;
    color: #777;
  }
  .m-title {
    font-weight: normal;
  }
  .infa {
    margin: 5px 0;
  }
  .article {
    margin-top: 10px;
    background: #fff;
    padding: 10px;
    border: 1px solid #eee;
    box-shadow: 2px 2px 4px #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/components/search/MentionList.vue